(function () {
  var STORAGE_KEY = 'cartReservationExpiresAt10m';
  var DURATION_MS = 10 * 60 * 1000;

  function getExpiry() {
    var stored = Number(sessionStorage.getItem(STORAGE_KEY));
    if (!stored || stored < Date.now()) {
      stored = Date.now() + DURATION_MS;
      sessionStorage.setItem(STORAGE_KEY, String(stored));
    }
    return stored;
  }

  function tick() {
    var elements = document.querySelectorAll('[data-cart-reservation-time]');
    if (!elements.length) return;

    var expiresAt = getExpiry();
    var remainingMs = Math.max(0, expiresAt - Date.now());
    var totalSeconds = Math.floor(remainingMs / 1000);
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    var formatted = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');

    elements.forEach(function (element) {
      element.textContent = formatted;
    });
  }

  try {
    tick();
    setInterval(tick, 1000);
  } catch (error) {
    // sessionStorage may be unavailable (private browsing, disabled storage); fail silently.
  }
})();
